module.exports = __webpack_public_path__ + "static/floating-action-button-action-styles-dont-43f260977358d844822abd9aae1476da.png";